module.exports = __webpack_public_path__ + "static/media/shuffle.bd169d47.mp3";